<div class="search">
  @if (!hideSearchButton()) {
    <button
      class="search__button"
      mat-icon-button
      matTooltip="Search"
      (click)="showSearch = !showSearch"
      [color]="showSearch ? 'accent' : 'primary'"
    >
      <mat-icon [matBadge]="!showSearch && control().value ? '...' : ''" matBadgeColor="accent"
        >search</mat-icon
      >
    </button>
  }
  <div class="search__container" [ngClass]="{ 'width-full': width() === 'full' }">
    @if (showSearch) {
      <mat-form-field class="search__input" appearance="outline" [class]="'width-' + width()">
        <mat-label>{{ placeholder() }}</mat-label>
        @if (loading()) {
          <mat-spinner matPrefix [diameter]="20"></mat-spinner>
        }
        <input
          type="search"
          #autocompleteInput
          placeholder="{{ placeholder() }}"
          aria-label="Search"
          matInput
          [formControl]="control()"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="itemSelected.emit($event.option.value)"
          [displayWith]="getAutocompleteItemValue.bind(this)"
          class="search__option-value"
        >
          @for (option of autocompleteItems(); track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
  </div>
</div>
